import { router } from 'routes'
import { Toast } from 'hooks/useToast'
import { RouterProvider } from 'react-router'
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { Suspense } from 'react'
import { AppDispatch, setEnvironment } from 'config/user/store'
import useDynamicFont from 'hooks/useDynamicFont'

const App = () => {
  const dispatch = useDispatch<AppDispatch>()
  useDynamicFont()

  useEffect(() => {
    const url = new URL(window.location.href)
    const hostname = url.hostname
    const parts = hostname.split('.')
    const environmentMode = parts[0]
    const environmentSettings = {
      mode: environmentMode,
      layout: 'default',
    }
    dispatch(setEnvironment(environmentSettings))
  }, [dispatch])

  return (
    <>
      <Suspense fallback={<div>loading...</div>}>
        <RouterProvider router={router} />
        <Toast className="toastContainer" />
      </Suspense>
    </>
  )
}

export default App
